import React from 'react';
import Login from './usersAuthentication/Login';
import Register from './usersAuthentication/Register';
import '../stylesheets/HomePage.css';

const Autenticacion = ({ authView, onClose }) => {
  return (
    <div className='login-register-container active'>
      <button className='close-auth-btn' onClick={onClose}>X</button>
      {authView === 'login' ? (
        <Login onClose={onClose} /> 
      ) : (
        <Register onClose={onClose} />
      )}
    </div>
  );
};

export default Autenticacion;
